import { tw } from "@careinfo/tailwind";
import Select from "react-select";
import Button from "../Reusable/Button";

const ChangeStatus = (props: any) => {
  const {
    handleAttachConsignment,
    openStatusPopup,
    setOpenStatusPopup,
    orderId,
    defaultValue,
    setDefaultValue,
    statuslist,
  } = props;

  const onChange = (value: any) => {
    setDefaultValue(value);
  };

  return (
    <div className={tw`flex gap-x-4 pt-4 items-center justify-center`}>
      <div className={tw`w-3/4`}>
        <Select
          className="basic-single"
          classNamePrefix="select"
          defaultValue={defaultValue}
          closeMenuOnSelect={true}
          options={statuslist}
          onChange={onChange}
        />
      </div>

      <div className={tw`w-[100px] `}>
        <Button
          label={"Update"}
          type={"button"}
          onClick={() => {
            handleAttachConsignment(orderId);
            setOpenStatusPopup(!openStatusPopup);
          }}
        />
      </div>
    </div>
  );
};

export default ChangeStatus;
